import type { AppFlowsContainer } from '#flows.js';
import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createUserProfileModel } from '#models/UserProfileModel.js';

export function createUserProfileContainer(flows: AppFlowsContainer, firestore: FirestoreContainer) {
  const $profile = createContainer('profile')
    .providedLazy('UserProfileClientModel', () => createUserProfileModel({ firestore, flows }))
    .dependent('ClientUserProfile', ['UserProfileClientModel'], ({ UserProfileClientModel }) => UserProfileClientModel)
    .provided('flows', flows);
  return $profile;
}

export type $UserProfileContainer = ReturnType<typeof createUserProfileContainer>;
export type UserProfileContainer = $UserProfileContainer['use'];
